<div *ngIf="loading; else loaded">
  <h3 class="panel-title"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</h3>
</div>
<ng-template #loaded>
  <div class="flex-left-column light-control-host">
    <div class="flex-center-row">
      <h3 class="panel-title">Sandbox Settings</h3>
    </div>

    <div>
      Review and modify sandbox settings for the current “{{ application ? application.name : '' }}” recovery test.
      <a href="{{ uiService.networkSandboxDocsUrl }}" target="_blank">Learn more.</a>
    </div>

    <ng-container *ngIf="accountService.networkSandboxEnabled">
      <form [formGroup]="launchTestSettingsFormModel" class="full-width">
        <div class="flex-center-row full-width">
          <div class="spacer full-width">
            <ng-container *ngIf="advancedNetworkSandbox">
              <h4 class="margin-top">Allow outbound access to these domains</h4>
              <p-scrollPanel [style]="{ width: '100%', maxHeight: '150px' }">
                <string-list-control
                  class="spacer"
                  [validationFunction]="isValidDomain"
                  [placeholderText]="domainAllowlistPlaceholderText"
                  (validated)="sandboxDomainsValidated($event)"
                  formControlName="sandboxAllowedDomains"
                ></string-list-control>
              </p-scrollPanel>

              <h5>Suggested Domains</h5>
              <div *ngIf="loadingSuggestedDomains; else loadedSuggestedDomains">
                <div class="no-suggestions">Loading...</div>
              </div>
              <ng-template #loadedSuggestedDomains>
                <p-scrollPanel [style]="{ width: '100%', maxHeight: '150px' }">
                  <div class="no-suggestions" *ngIf="suggestedDomains.length === 0">No suggestions available</div>
                  <div class="suggestion" *ngFor="let suggestion of suggestedDomains">
                    <button class="arpio-button" (click)="addAllowedDomain(suggestion.value)">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                    {{ suggestion.value }} <span class="suggestion-reason">({{ suggestion.reason }})</span>
                  </div>
                </p-scrollPanel>
              </ng-template>
            </ng-container>

            <h4 class="margin-top">Allow outbound access to these CIDR blocks</h4>
            <p-scrollPanel [style]="{ width: '100%', maxHeight: '150px' }">
              <string-list-control
                class="spacer"
                [validationFunction]="isValidCidr"
                [normalizeFunction]="normalizeCidr"
                [placeholderText]="whitelistPlaceholderText"
                (validated)="whitelistValidated($event)"
                formControlName="sandboxWhitelist"
              ></string-list-control>
            </p-scrollPanel>

            <ng-container *ngIf="advancedNetworkSandbox">
              <h5>Suggested CIDRs</h5>
              <div *ngIf="loadingSuggestedCidrs; else loadedSuggestedCidrs">
                <div class="no-suggestions">Loading...</div>
              </div>
              <ng-template #loadedSuggestedCidrs>
                <p-scrollPanel [style]="{ width: '100%', maxHeight: '150px' }">
                  <div class="no-suggestions" *ngIf="suggestedCidrs.length === 0">No suggestions available</div>
                  <div class="suggestion" *ngFor="let suggestion of suggestedCidrs">
                    <button class="arpio-button" (click)="addAllowedCidr(suggestion.value)">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                    {{ suggestion.value }} <span class="suggestion-reason">({{ suggestion.reason }})</span>
                  </div>
                </p-scrollPanel>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="!advancedNetworkSandbox">
              <div class="sandbox-checkbox half-margin-top">
                <label for="sandbox-allow-s3">
                  <input
                    id="sandbox-allow-s3"
                    class="arpio-checkbox"
                    type="checkbox"
                    formControlName="allowS3Checked"
                  />
                  Allow outbound access to S3 IPs
                </label>
              </div>
              <div class="sandbox-checkbox half-margin-top">
                <label>
                  <input
                    id="sandbox-allow-dynamo"
                    class="arpio-checkbox"
                    type="checkbox"
                    formControlName="allowDynamoChecked"
                  />
                  Allow outbound access to DynamoDB IPs
                </label>
              </div>
            </ng-container>
          </div>
        </div>
      </form>
    </ng-container>

    <div *ngIf="otherApplicationNames.length > 0" class="notice-block">
      <div class="notice-title">These changes will also apply to the following applications:</div>
      <truncated-list [items]="otherApplicationNames" maxVisible="10"></truncated-list>
    </div>

    <ng-container *ngIf="currentlySyncingMessage">
      <div class="error margin-top flex-center-row full-width">
        <p class="full-width">
          Arpio is applying your latest recovery point. Once it's done applying, you will be able to update your sandbox
          settings.
        </p>
      </div>
      <div class="error flex-center-row full-width">
        <div class="spacer"></div>
        <h1><i class="fa-solid fa-spinner fa-spin"></i></h1>
        <div class="spacer"></div>
      </div>
    </ng-container>
    <div class="flex-center-row margin-top full-width">
      <div class="spacer"></div>
      <button class="arpio-secondary-button" (click)="onCancelClick()">CANCEL</button>
      <button
        busy-button
        [busy]="launching"
        id="failover-button"
        class="arpio-button margin-left"
        (click)="onUpdateClick()"
        [disabled]="!canUpdate"
      >
        UPDATE
      </button>
      <div class="spacer"></div>
    </div>
  </div>
</ng-template>
